module.exports = __webpack_public_path__ + "img/icon-data.c2df3627.svg";